import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'
export { default as ButtonLoading } from './ButtonLoading.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible_outline-none focus-visible_ring-2 focus-visible_ring-ring focus-visible_ring-offset-2 disabled_pointer-events-none disabled_opacity-50 [&_svg]_pointer-events-none [&_svg]_size-4 [&_svg]_shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground shadow hover_bg-primary-hover',
        destructive: 'bg-destructive text-destructive-foreground shadow-sm hover_bg-destructive-hover',
        outline: 'border border-input text-foreground bg-background shadow-sm hover_bg-accent hover_text-accent-foreground',
        'dora-outline': 'border border-input bg-background shadow-sm text-sky-400 border-sky-400 hover_bg-sky-950',
        outlineDestructive:
          'border border-destructive text-destructive bg-background shadow-sm hover_bg-destructive/10 hover_text-destructive-hover',
        secondary: 'border border-input text-primary bg-background shadow-sm hover_bg-accent hover_text-accent-foreground',
        ghost: 'hover_bg-accent hover_text-accent-foreground',
        'dora-ghost': 'text-primary bg-transparent hover_bg-border-accent/40',
        link: 'text-primary underline-offset-4 hover_underline',
        internal: 'bg-internal text-primary-foreground shadow-sm hover_bg-internal/0.8',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-md px-3 text-xs',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
        'icon-sm': 'h-7 w-7 p-1.5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
